import { render, staticRenderFns } from "./InternationalLogisticsInformationDialog.vue?vue&type=template&id=e74d597e"
import script from "./InternationalLogisticsInformationDialog.vue?vue&type=script&lang=js"
export * from "./InternationalLogisticsInformationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports